import e from'./../ext-esm/style-inject/dist/style-inject.es.js';var s={spacing:"8"};e("");export{s as default};
